export const SuccessMessage = {
  login: 'loggedInSuccess',
  gameClose: 'gameClosedSuccess',
  betPlacedSuccessfully: 'betPlacedSuccessfully',
  playerEscapedSuccessfully: 'playerEscapedSuccessfully',
  betCancelledSuccessfully: 'betCancelledSuccessfully'
}

export const ErrorMessage = {
  internalServerError: 'internalServerError',
  unAuthorized: 'unAuthorized'
}

export const errorCodeToMessage = new Map([
  [600, 'internalServerError'],
  [601, 'loginFailedError'],
  [602, 'invalidCredentialsError'],
  [603, 'invalidTokenError'],
  [604, 'invalidSessionError'],
  [605, 'invalidAccessError'],
  [606, 'nonOperationalError'],
  [2001, 'createUserError'],
  [2002, 'operatorNotExistsError'],
  [2003, 'operatorPlayerNotExists'],
  [2004, 'dataMismatchError'],
  [2005, 'userNotFoundError'],
  [2006, 'duplicateEmailError'],
  [2007, 'operatorUserIsBlocked'],
  [3010, 'InvalidCurrencyCodeError'],
  [3011, 'insufficientFundsError'],
  [3012, 'unauthorizedError'],
  [3013, 'sessionNotFoundError'],
  [3014, 'playerBlockedError'],
  [3015, 'limitExceededError'],
  [3016, 'duplicateTransactionError'],
  [3017, 'debitNotFoundError'],
  [3018, 'debitSettledError'],
  [3019, 'invalidRollbackError'],
  [3020, 'currencyMismatchError'],
  [3021, 'invalidRequestError'],
  [3022, 'gameNotActiveError'],
  [3023, 'operatorInternalError'],
  [3024, 'operatorTimedOutError'],
  [3025, 'freeBetsNotFoundError']
])
